let portalURL = 'https://itcopera-uat.gravty.live';
let domain = new URL(portalURL).origin;
let pid = '7';
console.log('domain',domain);

export const environment = {
	production: false,
	apiendpoint:{
		url: domain,
		version:'/v1/',
		endpoint:'itc/gpms/'
	},
	gravtyendpoint:{
		url: domain,
		version:'/v1/',
		endpoint:'itc/gpms/opera/ui/v1/'
	},
	h_program_id : pid,
	host : function () {
		return this.apiendpoint.url + this.apiendpoint.version + this.apiendpoint.endpoint;
	},
	gravtyhost : function () {
		return this.gravtyendpoint.url  + this.gravtyendpoint.version + this.gravtyendpoint.endpoint;
	}
};